import { Role } from './Role';

const Anonymous = new Role('Anonymous', 'Utente Anonimo', [
  'procedure.read:front',
  'request.send:anonymous'
]);

const Citizen = new Role('Citizen', 'Cittadino', [
  'current-user.read',
  'current-user.edit',
  'procedure.read:front',
  // Invio delle richieste
  'request.write:own',
  'request.read:own',
  'request.send:own'
]);

const Manager = new Role('Manager', 'Gestore Domande', [
  'current-user.read',
  'procedure.write',
  'procedure.read',
  'procedure.read:front',
  'procedure.read:cancelled',
  'procedure.publish',
  'procedure.read:list',
  'procedure.rank:export',
  'procedure.export',
  'request.read',
  'request.rank.read'
]);

const Admin = new Role('Admin', 'Amministratore', [
  'current-user.read',
  'users.read',
  'users.read-selectable',
  'users.write',
  'users-grants.read',
  'users-grants.write',
  'pdnd.c020-logs-read',
  'system.check-queues',
  'procedure.read:front',
  'request.read',
  'request.check-closed',
  // Permessi Manager
  'procedure.write',
  'procedure.read',
  'procedure.read:list',
  'procedure.publish',
  'procedure.read:commission',
  'procedure.read:cancelled',
  'procedure.rank:export',
  'procedure.export',
  'request.rank.read'
]);

const AOOAdmin = new Role('AOOAdmin', 'Amministratore di AOO', [
  'current-user.read',
  'users-grants.read',
  'users-grants.write',
  'procedure.read:front'
]);

const System = new Role('System', 'Utente di Sistema', [
  'current-user.read',
  // Utenti
  'users.read',
  'users.write'
]);

const Commissioner = new Role('Commissioner', 'Commissario', [
  'current-user.read',
  'request.rank',
  'procedure.read:list',
  'procedure.read:commission',
  'request.read',
  'request.rank.read',
  'procedure.read:front',
  'procedure.rank:export',
  'procedure.export'
]);

/** Utente consultatore, in grado di leggere le richieste inviate dai cittadini */
const Consultant = new Role('Consultant', 'Consultatore', [
  'current-user.read',
  'request.read',
  'request.rank.read',
  'procedure.read:list',
  'procedure.read:consultation',
  'procedure.read:front'
]);

export const Roles = {
  Admin,
  Manager,
  System,
  Citizen,
  Anonymous,
  Commissioner,
  Consultant,
  AOOAdmin
};

export type RoleName = keyof typeof Roles;
